module.exports = __webpack_public_path__ + "img/02-lock-icon.efe57b28.svg";